class SettingsState {

  constructor () {
    this.visibilities = {}
  }

  hasVisibilitySetting (settingId) {
    return this.visibilities.hasOwnProperty(settingId)
  }

  isVisible (settingId) {
    return this.visibilities[settingId]
  }

  setVisible (settingId, visible) {
    this.visibilities[settingId] = visible
  }

}

export default SettingsState



// WEBPACK FOOTER //
// ./src/data/SettingsState.js